import StepBasic from './StepBasic.container';

export default StepBasic;
